import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import { jwtDecode } from "jwt-decode";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const [token, setToken] = useState(null);
  const [Username, setUsername] = useState(null);
  const [clinicID, setClinicID] = useState(null);


  // const [username, setusername] = useState(Username);

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.displayName);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        setusername(obj.username);
      }
    }
  }, [props.success]);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    if (storedToken) {
      try {
        const decodedToken = jwtDecode(storedToken);
        setUsername(decodedToken.username);
        setClinicID(decodedToken.clinicID); // ✅ important
      } catch (error) {
        console.error("Failed to decode token:", error);
      }
    }
  }, []); // ✅ run once only


  // useEffect(() => {
  //   const storedToken = localStorage.getItem('token');
  //   setToken(storedToken);
  //   // console.log('Token from LocalStorage:', storedToken);
  //   if (storedToken) {
  //     try {
  //       const decodedToken = jwtDecode(storedToken);
  //       // setUserId(decodedToken.userId);
  //       // console.log('UserID from Token:', decodedToken.userId);
  //       setUsername(decodedToken.username);
  //       // console.log('User name from Token:', decodedToken.username);
  //       // setclinicID(decodedToken.clinicID);
  //       // console.log('UserID from Token:', decodedToken.clinicID);
  //     } catch (error) {
  //       console.error('Failed to decode token:', error);
  //     }
  //   }
  // })
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{Username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href="/profile">
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          <DropdownItem
            tag={Link}
            to={clinicID ? `/Editclinic/${clinicID}` : "#"}
          >
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Practice")}
          </DropdownItem>


          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
